/* TO DO
- show tub size and tub size with variant
- silently errors when out of stock
*/


function setActivePriceCard(whichQuantity) {
   const priceCards = document.querySelectorAll('.tieredPricingOptions li');
   priceCards.forEach((thisPriceCard) => {
        thisPriceCard.classList.remove('active');
   });
   let targetQuantity = whichQuantity;
   if(targetQuantity > priceCards.length) {
    targetQuantity = priceCards.length;
   }
   const newActivePriceCard = document.querySelector('.tieredPricingOptions li[data-quantity="'+targetQuantity+'"]');
   if(newActivePriceCard) {
        newActivePriceCard.classList.add('active');
   }
}

function selectActiveOneTime() {
    // Need to find the correct once for this variant quantity:
    const activeOneTimeOption = document.querySelector('.shopify_subscriptions_app_block:not(.shopify_subscriptions_app_block--hidden) .tabs_wrapper .tab_label:not([aria-controls])');
    if(activeOneTimeOption) {
        activeOneTimeOption.click();           
    }
}

function selectActiveSubscription() {
    // Need to find the correct once for this variant quantity:
    const activeSubscriptionOption = document.querySelector('.shopify_subscriptions_app_block:not(.shopify_subscriptions_app_block--hidden) .tabs_wrapper .tab_label[aria-controls]');
    if(activeSubscriptionOption) {
        activeSubscriptionOption.click();           
    }
}

document.addEventListener("DOMContentLoaded", function() {
    const quantityInput = document.querySelector('.product__blocks .quantity__input');
    const priceCards = document.querySelectorAll('.tieredPricingOptions li');
    let currentQuantity;

    if(priceCards) {

        document.body.classList.add('initialLoad');

        priceCards.forEach((thisPriceCard) => {
            thisPriceCard.addEventListener('click', (event) => {
                if(event) {
                    event.preventDefault();
                }
                
                const thisPriceCard = event.target.closest('.pricingCard');
                const newQuantity = thisPriceCard.getAttribute('data-quantity');
                quantityInput.value = newQuantity;
                const changeEvent = new Event('change');
                quantityInput.dispatchEvent(changeEvent);
                setActivePriceCard(newQuantity);
                
            });
        });
    }



    if(quantityInput) {
        quantityInput.addEventListener('change', (event) => {
            currentQuantity = parseInt(quantityInput.value, 10);
            let whichVariantToSelect = null;
            // look for variants that match this quantity
            const quantityVariantSelects = document.querySelectorAll('variant-selects .product-form__input.option_subscription input');
            let thisQuantityVariantName, thisQuantity, thisQuantityNumeric;
            if (quantityVariantSelects) {
                quantityVariantSelects.forEach((thisQuantitySelect) => {
                    thisQuantityVariantName = thisQuantitySelect.value.toLowerCase();
                    // it should, but best to check:
                    if(thisQuantityVariantName.includes('multibuy')) {
                        thisQuantity = thisQuantityVariantName.split(" ")[1];
                        thisQuantityNumeric = parseInt(thisQuantity.replace("]", ""),10);
                        if(currentQuantity >= thisQuantityNumeric) {
                            whichVariantToSelect = thisQuantitySelect;
                        }
                    }
                });
            }
            // determine if a subscription is showing currently:
            const activeVariantRadioButtonOptions = document.querySelectorAll('.shopify_subscriptions_app_block:not(.shopify_subscriptions_app_block--hidden) .tab_radio');
            let subscriptionActive = false;
            if(activeVariantRadioButtonOptions) {
                activeVariantRadioButtonOptions.forEach((thisRadio) => {
                    if(thisRadio.getAttribute("id").includes("subscribe")) {
                        if(thisRadio.checked) {
                            subscriptionActive = true;
                        }
                    }                   
                });
            }


// IanD 10/26, Took this out as it was jumping up when the Quantity changed using +/-
 //           if(whichVariantToSelect) {
 //               // select the variant:
 //               whichVariantToSelect.click();
 //          }
            
            if(priceCards) {
               setActivePriceCard(currentQuantity);
            }

            if(subscriptionActive) {
                setTimeout(() => {
                    selectActiveSubscription();
                    document.body.classList.remove('initialLoad');
                }, 1500);
            } else {
                setTimeout(() => {
                    selectActiveOneTime();
                    document.body.classList.remove('initialLoad');
                }, 1500); 
            }
    
  

        });
    }



    // seems to be a bug in the Shopify subscription app so if a subscription has been active, clicking the one time purchase keeps the subscription active when adding to the cart
    const subscriptionOptionsForEachVariant = document.querySelectorAll('.shopify_subscriptions_app_container .tabs_wrapper .tab_label');
    if(subscriptionOptionsForEachVariant) {
        subscriptionOptionsForEachVariant.forEach((thisOption) => {
            if(thisOption.getAttribute('for').includes('tab_otp_')) {
                thisOption.addEventListener('click', (event) => {
                    const oneTimeRadio = event.target.closest('.toggle_card').querySelector('input[data-radio-type="one_time_purchase"]');
                    if(oneTimeRadio) {
                        oneTimeRadio.checked = true;
                    }
                });
            }
        });
    }


    if(document.getElementById('pricingCardOneTimeBenefits')) {
        const oneTimePricingCards = document.querySelectorAll('.shopify_subscriptions_app_block .tab_label:first-child');
        const contentToAdd = document.getElementById('pricingCardOneTimeBenefits').innerHTML;
        if(oneTimePricingCards) {
            oneTimePricingCards.forEach((thisPriceCard) => {
                thisPriceCard.insertAdjacentHTML('beforeend', contentToAdd);
            }); 
        }
    }

    

    // create the dropdown toggle:
    if(document.getElementById('deliveryFrequency')) {
        const subscribeAndSaveOptionCards = document.querySelectorAll('.shopify_subscriptions_app_block .subscribe_panel');
        const textContentToAdd = document.getElementById('deliveryFrequency').innerHTML;
        const deliveryPickerHTMLOpen = '<div class="subscriptionDurationPseudoSelect"><div class="select"><select class="form-control form-control--select"><option value="" disabled>'+textContentToAdd+'</option>';
        const deliveryPickerHTMLClose = '</select><svg class="icon icon-caret-down icon--small icon--thick" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.25 7.5L10 13.75L3.75 7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div></div>';
        let thisdeliveryPickerHTML;
        if(subscribeAndSaveOptionCards) {
            subscribeAndSaveOptionCards.forEach((thisPriceCard) => {
                thisdeliveryPickerHTML = deliveryPickerHTMLOpen;
                // get the values for this option:
              

                let thisCardsSellingOptions = thisPriceCard.querySelectorAll('.selling_group');
                let thisCardsSellingOptionValues = '';
                let firstOption = true;
                if(thisCardsSellingOptions) {
                    thisCardsSellingOptions.forEach((thisPriceCardsSellingValues) => {
                        if(thisPriceCardsSellingValues.querySelector('.group_list input[data-selling-plan-id]')) {
                            if(thisPriceCardsSellingValues.querySelector('.group_name')) {
                                thisCardsSellingOptionValues += '<option ';
                                if(firstOption) {
                                    thisCardsSellingOptionValues += 'selected ';
                                }
                                thisCardsSellingOptionValues += 'value="'+ thisPriceCardsSellingValues.querySelector('.group_list input[data-selling-plan-id]').getAttribute("data-selling-plan-id") +'">' + thisPriceCardsSellingValues.querySelector('.group_name').innerHTML + '</option>';
                            }
                            firstOption = false;
                        }
                    });
                    if(thisCardsSellingOptionValues != '') {
                        thisdeliveryPickerHTML += thisCardsSellingOptionValues;
                        thisdeliveryPickerHTML += deliveryPickerHTMLClose;
                        thisPriceCard.insertAdjacentHTML('afterbegin', thisdeliveryPickerHTML);
                    }
                }

               
            }); 

            const injectedDeliveryPickers = document.querySelectorAll('.shopify_subscriptions_app_block .subscriptionDurationPseudoSelect');
            if(injectedDeliveryPickers) {
                injectedDeliveryPickers.forEach((thisDeliveryPicker) => {
                    thisDeliveryPicker.addEventListener('change', (event) => {
     

                        const requiredInput = event.target.closest('.subscribe_panel').querySelector('.group_list input[data-selling-plan-id="'+event.target.value+'"]');
                        if(requiredInput) {
                            requiredInput.click();
                        }
                    });
                });
            }
        }
    }



    if(document.getElementById('pricingCardSubscribeSaveBenefits')) {
        const subscribeAndSavePricingCards = document.querySelectorAll('.shopify_subscriptions_app_block .tab_label:last-child');
        const contentToAdd = document.getElementById('pricingCardSubscribeSaveBenefits').innerHTML;
        if(subscribeAndSavePricingCards) {
            subscribeAndSavePricingCards.forEach((thisPriceCard) => {
                thisPriceCard.insertAdjacentHTML('beforeend', contentToAdd);
            }); 
        }
    }

    let lastPricingCard = null;
    if(document.getElementById('forceHighestPriceQuantityTier')) {
        // select the highest price tier:
        lastPricingCard = document.querySelector('.tieredPricingOptions li.pricingCard:last-child');
        if (lastPricingCard) {
            lastPricingCard.click();
        }
    }

    if(document.getElementById('defaultToSubscription')) {
        if(lastPricingCard) {
            // delay this to allow the above click to have happened to select the highest pricing tier
            setTimeout(() => {
              selectActiveSubscription();
            }, 1500);
        } else {
            selectActiveSubscription();
        }
    }

});

         